module.exports = __webpack_public_path__ + "static/media/inventory-card-img.655d987a.svg";